import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import BaseForm from 'containers/Base/BaseForm';
import {
  initialValues,
  validationSchema,
  initialState,
  generalSection,
  detailedSection,
} from './options';
import { getSecurityId, getSecurityCompanyName } from 'reducers/users';
import { getRegion } from 'reducers/region';
import { transformZoneForm } from 'utils/DataTransform/Zone/zoneForm';
import staticText from 'static/text_display.json';
import {
  riskMatrix,
  RISK_CONSEQUENCES,
  RISK_LIKELIHOOD,
} from 'utils/constants/risks';
import { translatedKeyValueText } from 'utils/methods/helpers';
import { ZoneInfo } from 'utils/constants/informationText';
import { HelpLinks } from 'utils/constants/helpLinks';

import { actions as zoneActions } from '../Modules/dataGridTable';
import { getZoneDetailsTransformed } from '../Selectors/zoneSelectors';
import { getSecurityCompanyServices } from 'reducers/securityCompany';
import { useTranslation } from 'react-i18next';

const ZoneForm = ({
  editMode,
  details,
  closeForm,
  createZone,
  updateZone,
  securityCompanyId,
  securityCompanyName,
  region,
  userAssignedDepartments,
  services,
  persistentStateName,
}) => {
  const [riskLevel, setRiskLevel] = useState();
  const { t } = useTranslation();
  const computeRiskLevel = zone => {
    const likelihood =
      zone.likelihood && zone.likelihood !== ''
        ? zone.likelihood
        : RISK_LIKELIHOOD.RARE.id;

    return riskMatrix[likelihood][
      t(get(zone, 'consequence', RISK_CONSEQUENCES.INSIGNIFICANT.id))
    ];
  };
  const handleFormUpdate = vals => {
    const riskLevel = computeRiskLevel(vals);
    vals.riskLevel = riskLevel;
    setRiskLevel(riskLevel);
  };
  const onCreate = values => {
    const payload = {
      ...values,
      regionId: region.id,
      regionName: region.name,
      securityCompanyName,
      securityCompanyId,
    };
    createZone({ zone: transformZoneForm(payload) });
  };

  const onEdit = values => {
    const id = get(details, 'others.id.value');
    const payload = {
      ...values,
      regionId: region.id,
      regionName: region.name,
      securityCompanyName,
      securityCompanyId,
    };

    updateZone({ id, zone: transformZoneForm(payload) });
  };

  return (
    <BaseForm
      imageRequired={false}
      edit={editMode}
      onChange={handleFormUpdate}
      initialValues={editMode ? initialValues(details) : initialState}
      formTitle={editMode ? 'Edit Zone' : 'Create Zone'}
      closeForm={closeForm}
      saveHoverText={
        editMode
          ? translatedKeyValueText('update_value_title', {
              value: details.generalInfo.name.value,
            })
          : staticText.managerial_view.zone.create
      }
      onSubmit={editMode ? onEdit : onCreate}
      validationSchema={validationSchema}
      generalSection={generalSection(userAssignedDepartments, services)}
      detailedSection={detailedSection(riskLevel)}
      hoverText={editMode ? details.generalInfo.name.value : ''}
      note={ZoneInfo.note}
      formInfo={{
        link: HelpLinks.zoneLink,
        value: HelpLinks.zoneText,
      }}
      persistentStateName={persistentStateName}
    />
  );
};

ZoneForm.propTypes = {
  editMode: PropTypes.bool,
  details: PropTypes.object,
  closeForm: PropTypes.func,
  createZone: PropTypes.func,
  updateZone: PropTypes.func,
  securityCompanyId: PropTypes.string,
  securityCompanyName: PropTypes.string,
  region: PropTypes.object,
  userAssignedDepartments: PropTypes.array,
  services: PropTypes.array,
  persistentStateName: PropTypes.string,
};

const mapStateToProps = state => ({
  details: getZoneDetailsTransformed(state),
  region: getRegion(state),
  securityCompanyId: getSecurityId(state),
  securityCompanyName: getSecurityCompanyName(state),
  services: getSecurityCompanyServices(state),
});

const mapDispatchToProps = dispatch => ({
  createZone: ({ zone }) => dispatch(zoneActions.createRowEntry({ zone })),
  updateZone: ({ id, zone }) =>
    dispatch(zoneActions.updateRowEntry({ id, zone })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZoneForm);
